import React, { useCallback, useEffect } from 'react'
import Resx from '@/components/Resx'
import { openErrorDialog } from '@/utils/dialogHelpers'
import { useBackgroundJobCard } from '@/components/backgroundJobs/useBackgroundJobCard'
import LoadingIndicator from '@/components/LoadingIndicator'
import { StatusBasedCard } from '@/report-app/pages/reporting/submissions/submit/statusBasedCard'

function BackgroundJobCard ({ submitProgress,
  reportInstanceGroupId,
  backgroundJobMetadata,
  bgJobSubmitProgress,
  startCardSubmitProgress,
  bgJobEndpoint,
  headerText,
  beforeStartText,
  onJobStarted,
  dataCy
}) {
  const { status,
    cardColor,
    bgJobCanStart,
    backgroundJobMessages,
    message,
    icon,
    hasError
  } = useBackgroundJobCard(backgroundJobMetadata,
    bgJobSubmitProgress,
    startCardSubmitProgress,
    submitProgress)

  useEffect(() => {
    if (bgJobCanStart) {
      onJobStarted && onJobStarted(bgJobSubmitProgress)
      bgJobEndpoint(reportInstanceGroupId)
        .catch(openErrorDialog)
    }
  }, [bgJobCanStart, bgJobEndpoint, bgJobSubmitProgress, onJobStarted, reportInstanceGroupId])

  const onRetryClick = useCallback(() => bgJobEndpoint(reportInstanceGroupId).catch(openErrorDialog),
    [bgJobEndpoint, reportInstanceGroupId])

  return <StatusBasedCard dataCy={dataCy} backgroundJobMessages={backgroundJobMessages} icon={icon}
    beforeStartText={beforeStartText} headerText={headerText} cardColor={cardColor} status={status}
    finishedMessage={message} onRetryClick={onRetryClick} hasError={hasError}>
    <LoadingIndicator inline />
    <Resx name={message} />
  </StatusBasedCard>
}

export { BackgroundJobCard }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/submit/backgroundJobCard.js